import { render } from "./ModalDialog.vue?vue&type=template&id=ba1a50be&scoped=true"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=ba1a50be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1a50be"]])

export default __exports__